import { kindOf, type ContentFormat, type DraftStatus, type ReelType, type RenderJobDto, type ThoughtStatus } from '@app/shared';
import type { Dictionary } from '../i18n';
import { formatDate } from './format';

type Tone = 'neutral' | 'accent' | 'destructive';

/** Badge tone of a thought status. */
export const THOUGHT_TONE: Record<ThoughtStatus, Tone> = {
  transcribing: 'neutral',
  ideating: 'neutral',
  ready: 'accent',
  failed: 'destructive',
};

/** Badge tone of a draft status. */
export const DRAFT_TONE: Record<DraftStatus, Tone> = {
  new: 'neutral',
  writing: 'neutral',
  ready: 'neutral',
  editing: 'neutral',
  approved: 'accent',
  failed: 'destructive',
};

/** The first line of a transcript excerpt. */
export function firstLine(text: string | null): string {
  return (text ?? '').split('\n')[0]!.trim();
}

/** «Рилс · Сцены», «Рилс · Схема», «Рилс · Подборка», «Карусель» — the kind of a draft. */
export function kindLabel(format: ContentFormat, type: ReelType, t: Dictionary): string {
  return t.kinds[kindOf(format, type)];
}

/** «Схема · Мел», «Подборка · Стекло»; the theme alone for «Сцены» and a carousel. */
export function styleLabel(job: Pick<RenderJobDto, 'type' | 'styleName'>, t: Dictionary): string {
  return job.type === 'scenes' ? job.styleName : `${t.types[job.type]} · ${job.styleName}`;
}

/** «Рилс · Схема · Мел», «Анимированная карусель · Поп» — what a build is (the result screen). */
export function renderKindLine(job: Pick<RenderJobDto, 'format' | 'type' | 'animated' | 'styleName'>, t: Dictionary): string {
  const kind =
    job.format === 'reel' ? t.render.kindReel : job.animated ? t.render.kindCarouselAnimated : t.render.kindCarousel;
  return `${kind} · ${styleLabel(job, t)}`;
}

/** «Рилс · Бумага · 30 сентября», «Рилс · Схема · Мел · …» — a finished build in «Готовое». */
export function renderCardLine(
  job: Pick<RenderJobDto, 'format' | 'type' | 'animated' | 'styleName' | 'finishedAt' | 'createdAt'>,
  t: Dictionary,
): string {
  return `${renderKindLine(job, t)} · ${formatDate(job.finishedAt ?? job.createdAt)}`;
}
